import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenUpLeft = function ArrowCircleBrokenUpLeft(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.5896 21.6606c-3.3362.8909-7.0434.0278-9.6607-2.5895-3.9052-3.9053-3.9052-10.237 0-14.1422 3.9053-3.9052 10.2369-3.9052 14.1422 0 2.6173 2.6173 3.4804 6.3245 2.5895 9.6607m-12.6604.4105v-6m0 0h6m-6 0L19 19"
    })
  }));
};
export default ArrowCircleBrokenUpLeft;